import { OffersResponseDto } from '@wwt/entities/api/search-response'
import { Offer } from '@wwt/entities/search-response'
import { extractOfferFromSearchResponse } from '@wwt/shared/utils'

export const searchOffersAdapter = (searchResponse: OffersResponseDto) => {
	const offers = searchResponse.offers
		.map(offerId => {
			return extractOfferFromSearchResponse(
				searchResponse,
				offerId.nonPersistingOfferId
			)
		})
		.filter(offer => offer !== null) as Offer[]

	return offers
}
